import { useMemo } from 'react'
import useConfig from './useConfig'
import { PlugToken } from '../interfaces/common'

const useToken = (identifier: string | undefined) => {
  const { tokens } = useConfig()

  const token = useMemo(() => {
    if (!identifier) return

    const address = identifier.toLowerCase()

    return tokens.find(
      (token) => token.id === identifier || token.address?.toLowerCase() === address
    )
  }, [tokens, identifier])

  return token || ({} as Partial<PlugToken>)
}

export default useToken
